import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { ssoCertificateValidator, ssoEnforcementTypeValidator, ssoExternalUserEnforcementValidator, } from '#validation';
const ssoConfigUpdateSchema = z
    .object({
    certificate: ssoCertificateValidator,
    /**
     * @deprecated
     *
     * TODO: https://lucidlink.atlassian.net/browse/LUCID-24425
     *
     * Date: 21.11.2025
     * */
    enforcementType: ssoEnforcementTypeValidator,
    externalUsersEnforcement: ssoExternalUserEnforcementValidator,
})
    .partial();
export class SsoConfigUpdateDto extends createZodDto(ssoConfigUpdateSchema) {
}
